import React from 'react'
import {AuthProvider} from './auth-context'
import {UserProvider} from './user-context'
import {TranslationProvider} from './translation-context'
import locale from 'antd/es/locale/de_DE'
import {ConfigProvider, Empty} from "antd";
import moment from 'moment'
import 'moment/locale/de'
moment.locale('de')

function AppProviders({language, children}) {
    return (
        <ConfigProvider
            locale={locale}
            renderEmpty={() => <Empty description='Keine Daten'/>}
        >
            <TranslationProvider language={language} >
                <AuthProvider>
                    <UserProvider>{children}</UserProvider>
                </AuthProvider>
            </TranslationProvider>
        </ConfigProvider>
    )
}

export default AppProviders